<template>
  <div>
    <product-feature
      v-for="feature in features"
      :key="feature.id"
      :heading="feature.heading"
      :body="feature.body"
      :benefit="feature.benefit"
      :media-image="mediaImage(feature)"
    ></product-feature>
  </div>
</template>

<script>
  import ProductFeature from './ProductFeature.vue';

  export default {
    name: 'ProductFeatures',
    props: {
      features: {
        type: Array,
        validator: validateSpecProp
      }
    },
    methods: {
      mediaImage(feature) {return feature.media ? feature.media[0] : null}
    },
    components: {
      'product-feature': ProductFeature
    }
  }

  //////////

  function validateSpecProp( value ) {
    let pass = true;

    value.forEach((item)=>{
      if( typeof item !== 'object') {
        pass = false;
      }
    });

    return pass;
  }
</script>

<style lang="scss" scoped>
</style>
